<template>
  <section class="container">
    <div class="management_top_box">
      <h4>{{ $t("management.emailTemplateManagement") }}</h4>
    </div>
    <div class="wrap_con type_bt_wrap">
      <div class="mb-5 pb-3">
        <div class="float-end">
          <div class="list_top_search d-flex">
            <input
              type="text"
              id="searchWord"
              v-model="form.searchWord"
              name="searchWord"
              value=""
              class="m-1 form-control"
            />
            <button @click="searchBtn" class="btn btn-primary btn-lg">
              {{ $t("common.search") }}
            </button>
          </div>
        </div>
      </div>
      <div>
        <div style="text-align: right">
          <router-link
            :to="{ name: 'emailTemplateForm' }"
            class="btn btn-primary btn-md mb-2"
            >{{ $t("common.add") }}</router-link
          >
        </div>
        <div>
          <table class="list_tbl">
            <thead>
              <tr>
                <th class="mobile_row">
                  {{ $t("management.templateTitle")
                  }}<span class="mobile_vt"
                    >/ {{ $t("support.notice.classify") }} /
                    {{ $t("support.notice.writer") }} / {{ $t("support.notice.date") }} /
                    {{ $t("support.notice.file") }}</span
                  >
                </th>
                <th class="mobile_h">{{ $t("common.writer") }}</th>
                <th class="mobile_h">{{ $t("common.date") }}</th>
              </tr>
            </thead>
            <tbody v-if="templateList.length != 0">
              <tr
                v-for="(tem, index) in templateList"
                :key="index"
                @click="goTemplateForm(tem.templateId)"
                class="active_mouseover"
              >
                <td class="text-left">
                  {{ tem.title }}
                </td>
                <td>{{ tem.userName }}</td>
                <td>{{ tem.firstRegDatetime }}</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="5">{{ $t("common.noData") }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { getEmailTemplateList } from "@/api/mail";

export default {
  data() {
    return {
      templateList: "",
      form: { searchWord: "" },
    };
  },
  methods: {
    async fetchData() {
      try {
        const { data } = await getEmailTemplateList(this.form);
        this.templateList = data.templateList;
      } catch (error) {
        console.log(error);
      }
    },
    searchBtn() {
      this.fetchData();
    },
    goTemplateForm(templateId) {
      this.$router.push({
        name: "emailTemplateForm",
        params: { templateId: templateId },
      });
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>

<style></style>
